module.exports = __webpack_public_path__ + "images/pl_logo.png";